import { FC } from 'react';

import './style.css';
import Text from '../Text';

interface Props {
    label: string;
    Icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
}

const ContentTitle: FC<Props> = ({ label, Icon }) => {
    return (
        <div className="content_title">
            {Icon && <Icon className="content_title_logo" />}
            <Text variant="title">{label}</Text>
        </div>
    );
};

export default ContentTitle;